export default "__VITE_ASSET__b8ceaf60__"